
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/detection",
      function () {
        return require("private-next-pages/demo/detection.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/detection"])
      });
    }
  